import { commonUtils } from './common_utils';
import { counters } from './counters';

const shareLinkByEmail = {
    url: Routing.generate('ajax_submit_share_link'),
    validate() {
        let shareLinkName = $('#shareLinkName');
        let shareLinkFromEmail = $('#shareLinkFromEmail');
        let shareLinkEmail = $('#shareLinkEmail');
        shareLinkName.val(shareLinkName.val().trim());
        shareLinkEmail.val(shareLinkEmail.val().trim());

        if (commonUtils.isEmpty(shareLinkName.val())) {
            alert(Translations.invalid_name);
            shareLinkName.focus();
            return false;
        }
        if (!commonUtils.isValidEmail(shareLinkFromEmail.val())) {
            alert(Translations.invalid_email);
            shareLinkFromEmail.focus();
            return false;
        }
        if (commonUtils.isEmpty(shareLinkEmail.val())) {
            alert(Translations.invalid_email);
            shareLinkEmail.focus();
            return false;
        }

        let multipleEmails = shareLinkEmail.val().replace(/ /g, '').split(',');
        if (multipleEmails.length > 10) {
            alert(Translations.invalid_max_emails);
            shareLinkEmail.focus();
            return false;
        }
        for (const element of multipleEmails) {
            if (!commonUtils.isValidEmail(element)) {
                alert(Translations.invalid_email);
                shareLinkEmail.focus();
                return false;
            }
        }

        return true;
    },
    send() {
        $('#shareLinkSubmit').prop('disabled', true);
        let params = $('#shareLinkForm').serialize();
        $('#loadingImg').show();
        $.post(this.url, params, function (response) {
            $('#shareLinkSubmit').prop('disabled', false);
            $('#loadingImg').hide();
            $('#shareLinkEmail, #shareLinkComment').val('');

            if (!commonUtils.isUserLogin()) {
                $('#shareLinkName, #shareLinkFromEmail').val('');
            }

            commonUtils.showNotification(response.message);
            $('#viewShareLinkByEmail').hide();
            counters.incrementByType('send-link-to-friend-mobile');
        });

        return false;
    },
};

$(function () {
    $('.shareLinkByEmail').on('click', function () {
        let viewShareLinkByEmail = $('#viewShareLinkByEmail');
        commonUtils.hideOpenedMenu();
        $(this).closest('div .activeAddClass').toggleClass('open_menu');

        if (!viewShareLinkByEmail.is(':visible')) {
            viewShareLinkByEmail.show();
            setTimeout(() => {
                viewShareLinkByEmail.find('#shareLinkName').focus();

                commonUtils.loadCloudFlareTurnstileJs().catch((error) => {
                    console.error('Error loading script from send to friend:', error);
                });
            }, 10);
        }

        $('html,body').animate({ scrollTop: viewShareLinkByEmail.offset().top }, 500);
    });

    $('.hideShareLinkByEmail').on('click', function () {
        $('#viewShareLinkByEmail').hide();
    });

    $('#shareLinkForm').on('submit', function (event) {
        event.preventDefault();
        if (shareLinkByEmail.validate()) {
            shareLinkByEmail.send();
        }
        return false;
    });
});
